import React, { useMemo, useState, useEffect } from "react";
import { Icon, Tooltip, Whisper, Checkbox } from "rsuite";
import styled from "styled-components";

import { DEFAULT_PER_PAGE_SMALL } from "const";
import ColorBadge from "components/base/ColorBadge";
import { Header } from "./styled";
import AllocatedNumbers from "./AllocatedNumbers/AllocatedNumbers";
import Trunks from "./Trunks";


export default (
    {
        trunks = [],
        service,
        account,
        isMobile,
        accountId,
        activeTab,
        permissions,
        trunksInited,
        trunksLoading,
        currentTrunkId,
        currentSupplier,
        supplierPriceList,
        suppliersPrefixList,
        suppliersPrefixListCount,
        suppliersPrefixListPage,
        suppliersPrefixListPerPage,
        suppliersPrefixLoading,
        suppliersPrefixDropdownList,

        raterc_list,
        paymentTermsList,
        ipOptionList,
        globalSettings,
        allocatedNumbers,
        allocatedNumbersPage,
        allocatedNumbersCount,
        allocatedNumbersPerPage,
        allocatedNumbersLoading,
        allocatedNumbersTotalCount,
        accountServicePlanList,

        trunkDownloadNumbers,

        setCurrentTrunkId,
        unsetTrunksInited,
        getAccountTrunk,

        createTrafficLimit,
        modifyTrafficLimit,
        removeTrafficLimit,

        setEmptyPrefixes,

        setCurrentRangeNumber,
        getSupplierPrefixes,
        getSupplierPriceList,
        getSupplierPrefixesDropdown,

        rerouteStatusList
    }
) => {

    const [showAllocatedNumbersModal, setShowAllocatedNumbersModal] = useState(false);
    const [showClosedTrunks, setShowClosedTrunks] = useState(false);
    const [numbersTableReadonly, setNumbersTableReadonly] = useState(false);
    const [savedParams, setSavedParams] = useState({});

    const transitDefaultLimit = useMemo(() => globalSettings ? globalSettings.sms_supplier_transit_trunk_limit_day : null, [globalSettings]);

    useEffect(() => {
        if (!currentTrunkId || !trunks.length) {
            setEmptyPrefixes();
        }
    }, [trunks, currentTrunkId])

    useEffect(() => {
        // if (!trunks.length ) {
        //     getTrunks(true);
        // } else 
        const filteredTrunks = trunks.filter((trunk) => !trunk.closed);
        if (filteredTrunks.length && !currentTrunkId) {
            setCurrentTrunkId(filteredTrunks[0]?.id)
        } else {
            // setCurrentTrunkId(null);
            // setEmptyPrefixes();
        }
    }, [trunks]);

    useEffect(() => {
        // getTrunks();
        if (currentSupplier?.supplier_id) {
            // if (!trunks.length) {
            getTrunks();
            // }
        }

        return () => {
            setCurrentTrunkId(null);
            unsetTrunksInited();
        }
    }, [currentSupplier]);

    const getTrunks = (withNumbers = false) => {
        getAccountTrunk(currentSupplier?.supplier_id, "transit");

        // if (Object.keys(numbersParams).length && withNumbers && currentTrunkId) {
        //     const {group, filter, page, per_page, sort} = numbersParams;

        //     getAccountAllocatedNumbers(accountId, currentTrunkId, service, group, filter, page, per_page, sort)
        // }
    };


    const getNumbers = (group, filter, page, per_page, sort, first = false) => {
        if (currentTrunkId) {
            // setNumbersParams(params);
            const curPerPage = per_page || DEFAULT_PER_PAGE_SMALL;
            const params = { group, filter, page, per_page: curPerPage, sort };
            setSavedParams(params);
            // getAccountAllocatedNumbers(accountId, currentTrunkId, service, group, filter, page, curPerPage, sort);
            // sms.supplier_prefix:get_list

            // const savedSupplier = localStorage.getItem("CURRENT_SUPPLIER");

            let callback;

            if (!trunks.length) {// && savedSupplier === JSON.stringify(currentSupplier)) {
                callback = setEmptyPrefixes;
            }

            getSupplierPrefixes(currentTrunkId, filter, page, curPerPage, sort, true, callback);
        }
    };

    const setTrunk = (trunk_id) => {
        if (allocatedNumbersLoading) return;

        const activeTrunk = trunks.find((trunk) => trunk.id === trunk_id);
        const numbersTableReadonly = activeTrunk ? activeTrunk.closed : true;

        setCurrentTrunkId(trunk_id);
        // setNumbersTableReadonly(numbersTableReadonly);
    };

    const currentTrunk = trunks.find(trunk => trunk.id === currentTrunkId) || {};

    const columns = [
        {
            id: "trunk_type_name",
            label: "Name",
            align: "center",
            value: ({ name, comment_admin, comment_dialer }) => {

                return <ColumnDataWithIcon>
                    <span classname="name">{name}</span>
                    {(comment_admin && comment_dialer) ? <span className="icon">
                        <Whisper
                            disabled={!(comment_admin && comment_dialer)}
                            trigger="hover"
                            speaker={<Tooltip><div>Admin's comment: {comment_admin}<br /><br />Dialer's comment: {comment_dialer}</div></Tooltip>}
                        >
                            <Icon icon="info" />
                        </Whisper>
                    </span> : <></>}
                </ColumnDataWithIcon>
            },
            minWidth: 180,
            flexGrow: 1
        },
        {
            id: "mdr_billing_status",
            label: "Status",
            align: "center",
            value: ({ message_protocol, organic_ip, organic_bound, ip_list }) => {
                const statusList = ip_list.length ? ip_list.map(ip => ip.bound) : [];

                const normalIPMarkers = statusList.map(status => {
                    const badgeColor = status ? "var(--color-success)" : "var(--color-error2)";

                    return ["smpp", "smpp_mo"].includes(message_protocol)
                        ? <ColorBadge badgeColor={badgeColor}></ColorBadge>
                        : <></>
                });

                const bindMarkerColor = organic_bound ? "var(--color-success)" : "var(--color-error2)";

                return <>{normalIPMarkers}{organic_ip ? "/ " : ""}{organic_ip ? <ColorBadge badgeColor={bindMarkerColor}></ColorBadge> : <></>}</>
            },
            minWidth: 80,
            flexGrow: 1
        },
        {
            id: "systemid",
            label: "System ID",
            align: "center",
            value: ({ systemid }) => {
                return systemid || "—";
            },
            minWidth: 150,
            flexGrow: 1
        },
        {
            id: "price",
            label: "Price",
            align: "center",
            value: ({ price }) => {
                const priceName = price?.name;
                return priceName ? <Whisper
                    trigger="hover"
                    speaker={<Tooltip>{priceName}</Tooltip>}
                >
                    <span>{priceName}</span>
                </Whisper> : "—";
            },
            minWidth: 200,
            flexGrow: 1
        },
        {
            id: "login_list",
            label: "IPs",
            align: "center",
            value: ({ ip_list }) => {
                const dataValues = ip_list && ip_list.slice(0, 3).map(value => {
                    return `${value?.ip}`;
                }).join(", ");

                const tooltipData = ip_list ? ip_list.map(value => {
                    const badgeStyle = { marginTop: "2px", marginRight: "4px", width: "8px", height: "8px" };
                    const badgeColor = value?.bound ? "var(--color-success)" : "var(--color-error2)";
                    return <p><ColorBadge style={badgeStyle} badgeColor={badgeColor} /> {`${value?.ip}`}</p>
                }) : "";

                if (ip_list && ip_list.length) {
                    return (
                        <Whisper
                            enterable
                            placement="auto"
                            speaker={
                                <Tooltip>{tooltipData}</Tooltip>
                            }
                        >
                            <span>{dataValues}{ip_list.length > 3 ? "..." : ""}</span>
                        </Whisper>
                    )
                }

                return "—";
            },
            minWidth: 180,
            flexGrow: 1
        },
        {
            id: "message_protocol",
            label: "Message protocol",
            dataKey: "message_protocol",
            align: "center",
            width: 130
        },
        {
            id: "tariffication_all",
            dataKey: "tariffication_all",
            // showLabelOnCreate: true,
            label: "Bill all traffic",

            value: ({ tariffication_all }) => {
                return (
                    <StyledCheckbox
                        disabled={true}
                        defaultChecked={tariffication_all}
                        checked={tariffication_all}
                    />
                )
            },
            width: 95,
            align: "center"
        },
        {
            id: "custom_ranges",
            dataKey: "custom_ranges",
            // showLabelOnCreate: true,
            label: "Custom ranges trunk",

            value: ({ custom_ranges }) => {
                return (
                    <StyledCheckbox
                        disabled={true}
                        defaultChecked={false}
                        checked={custom_ranges}
                    />
                )
            },
            width: 135,
            align: "center"
        }
    ];

    const mobileColumns = [
        {
            id: "supplier_plan_name",
            label: "Supplier Plan Name",
            value: (({ supplier_plan_name, type }) => (
                <div className={"table-two-staged__cell"}>
                    <div className="table-two-staged__cell-first">{`${type}`}</div>
                    <div className="table-two-staged__cell-second">{supplier_plan_name}</div>
                </div>
            )
            ),
            minWidth: 150,
            flexGrow: 1
        },
    ];

    const customRangesTrunk = currentTrunk?.custom_ranges;

    return (
        <>

            <Trunks
                {...{
                    trunks,
                    columns,
                    service,
                    account,
                    isMobile,
                    activeTab,
                    mobileColumns,
                    trunksLoading,
                    currentTrunkId,
                    currentSupplier,
                    ipOptionList,
                    accountServicePlanList,
                    transitDefaultLimit,
                    allocatedNumbersLoading,
                    trunkDownloadNumbers,
                    createTrafficLimit,
                    modifyTrafficLimit,
                    removeTrafficLimit,

                    rerouteStatusList
                }}
                isTransitTrunks

                acc_key={accountId}
                trunk_id={currentTrunkId}
                account_name={account?.name}
                paymentTermsList={paymentTermsList}
                closedTrunksShow={showClosedTrunks}

                savedParams={savedParams}

                setTrunk={setTrunk}
                getTrunks={getTrunks}
                getNumbers={getNumbers}
                supplierPriceList={supplierPriceList}

                setCurrentTrunkId={setCurrentTrunkId}
                getSupplierPriceList={getSupplierPriceList}
                onAllocateNumbers={() => setShowAllocatedNumbersModal(true)}
                setClosedTrunksShow={() => setShowClosedTrunks(!showClosedTrunks)}
                setCurrentRangeNumber={setCurrentRangeNumber}
            />

            <Header>Prefixes</Header>

            <AllocatedNumbers
                {...{
                    activeTab,
                    account,
                    service,
                    permissions,
                    // currentRangeNumber,
                    allocatedNumbers,
                    allocatedNumbersLoading,
                    allocatedNumbersCount,
                    allocatedNumbersTotalCount,
                    allocatedNumbersPage,
                    allocatedNumbersPerPage,
                    showAllocatedNumbersModal,
                    customRangesTrunk,
                    // getTrunkNumberCsvById,

                    currentSupplier,
                    suppliersPrefixList,
                    suppliersPrefixListCount,
                    suppliersPrefixListPage,
                    suppliersPrefixListPerPage,
                    suppliersPrefixLoading,
                    suppliersPrefixDropdownList,

                    trunkDownloadNumbers,

                    trunksLoading,
                    trunks,
                    trunksInited,
                    raterc_list,

                    createTrafficLimit,
                    modifyTrafficLimit,
                    removeTrafficLimit
                }}

                isTransitTrunks

                trunk_id={currentTrunkId}
                closeAllocatedNumbersModal={() => setShowAllocatedNumbersModal(false)}
                getSupplierPrefixes={getSupplierPrefixes}
                getSupplierPrefixesDropdown={getSupplierPrefixesDropdown}
                sp_key={currentTrunk.sp_key}
                sp_auth={currentTrunk.sp_auth}
                spOtpType={currentTrunk.sp_otp_type}
                acc_key={accountId}
                account_name={account.name}
                getNumbers={getNumbers}
                readonly={numbersTableReadonly}
                getTrunks={() => getTrunks(true)}
            />

        </>
    )
}


const StyledCheckbox = styled(Checkbox)`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    && .rs-checkbox-wrapper {
        top: 2px !important;
    }
`;

const ColumnDataWithIcon = styled.div`
    && .icon {
        margin-left: 10px;
    }
`;